/** Monta folhas fisicas a partir do documento renderizado pelo Angular. */
export function paginarVenda(origem: HTMLElement, destino: HTMLElement): HTMLElement[] {
    const folhas: HTMLElement[] = [];
    const estilo = (elemento: HTMLElement, valores: Record<string, string>) => {
        Object.entries(valores).forEach(([nome, valor]) => elemento.style.setProperty(nome, valor, 'important'));
    };
    for (const documento of Array.from(origem.querySelectorAll<HTMLElement>('.page'))) {
        const report = documento.querySelector<HTMLElement>('.report')!;
        const tabela = report.querySelector<HTMLTableElement>('.items-table')!;
        const rodape = report.querySelector<HTMLElement>('.print-bottom-block')!;
        const blocos = Array.from(report.children) as HTMLElement[];
        const antes = blocos.slice(0, blocos.indexOf(tabela));
        const depois = blocos.slice(blocos.indexOf(tabela) + 1).filter(bloco => bloco !== rodape);
        const grupos: HTMLElement[][] = [];
        for (const linha of Array.from(tabela.tBodies[0].rows)) {
            if (linha.classList.contains('item-row') || !grupos.length) grupos.push([]);
            grupos[grupos.length - 1].push(linha);
        }
        const paginasDocumento: HTMLElement[] = [];
        let conteudo: HTMLElement;
        let corpoTabela: HTMLTableSectionElement;
        let moldura: HTMLElement;
        let baseAtual: HTMLElement;
        let areaAtual: HTMLElement;
        const atualizarLimite = (comPagamento: boolean) => {
            const pagamento = baseAtual.querySelector<HTMLElement>('.payment-section');
            if (pagamento) pagamento.style.display = comPagamento ? '' : 'none';
            if (baseAtual.getBoundingClientRect().top <= areaAtual.getBoundingClientRect().top) {
                throw new Error('O rodape excede a altura util de uma folha A4.');
            }
        };
        const novaPagina = () => {
            const folha = documento.cloneNode(false) as HTMLElement;
            folha.classList.add('physical-page');
            estilo(folha, {width: '210mm', 'min-width': '210mm', 'max-width': '210mm',
                height: '297mm', 'min-height': '297mm', padding: '7mm', border: '0',
                'box-sizing': 'border-box', transform: 'none', overflow: 'hidden', display: 'block'});
            const area = report.cloneNode(false) as HTMLElement;
            estilo(area, {position: 'relative', display: 'block', height: '283mm',
                'min-height': '283mm', overflow: 'visible'});
            conteudo = document.createElement('div');
            conteudo.className = 'physical-page-content';
            estilo(conteudo, {display: 'flow-root', width: '100%'});
            // As demais folhas repetem a identificacao da venda; os dados completos ficam na primeira.
            const cabecalho = paginasDocumento.length ? antes.filter(bloco => bloco.matches('.header-grid')) : antes;
            cabecalho.forEach(bloco => conteudo.append(bloco.cloneNode(true)));
            moldura = document.createElement('div');
            // Herda a cor da folha somente durante a impressao PB; a previa permanece colorida.
            estilo(moldura, {border: '1px solid var(--sale-items-border, #d9e2ef)', 'border-radius': '8px', overflow: 'hidden', 'margin-top': '8px'});
            const trecho = tabela.cloneNode(true) as HTMLTableElement;
            estilo(trecho, {border: '0', margin: '0', width: '100%', 'border-collapse': 'separate', 'border-spacing': '0'});
            corpoTabela = trecho.tBodies[0];
            corpoTabela.replaceChildren();
            moldura.append(trecho);
            conteudo.append(moldura);
            const base = rodape.cloneNode(true) as HTMLElement;
            estilo(base, {position: 'absolute', bottom: '0', left: '0', right: '0', 'margin-top': '0'});
            area.append(conteudo, base);
            folha.append(area);
            destino.append(folha);
            baseAtual = base;
            areaAtual = area;
            atualizarLimite(false);
            paginasDocumento.push(folha);
            folhas.push(folha);
        };
        const cabe = () => {
            // Compara posicoes na mesma escala, sem arredondar a altura A4 ou do rodape.
            // A folga permanece em 8px de layout, independentemente do zoom da previa.
            const area = areaAtual.getBoundingClientRect();
            const escala = area.width / parseFloat(getComputedStyle(areaAtual).width);
            return conteudo.getBoundingClientRect().bottom + 8 * escala
                <= baseAtual.getBoundingClientRect().top;
        };
        novaPagina();
        // As folhas de produtos reservam somente identificacao e paginacao.
        for (const grupo of grupos) {
            const linhas = grupo.map(linha => linha.cloneNode(true) as HTMLElement);
            corpoTabela!.append(...linhas);
            if (!cabe()) {
                linhas.forEach(linha => linha.remove());
                if (!corpoTabela!.rows.length) moldura!.remove();
                novaPagina();
                corpoTabela!.append(...linhas);
                if (!cabe()) throw new Error('Um produto e seus seriais excedem o espaco util de uma folha A4.');
            }
        }
        // Totais seguem os produtos; pagamento nao reserva espaco nesta etapa.
        for (const bloco of depois) {
            const final = bloco.cloneNode(true) as HTMLElement;
            conteudo!.append(final);
            if (!cabe()) {
                final.remove();
                // Quando os totais nao cabem, leva o ultimo produto junto, com seus seriais.
                const ultimoGrupo: HTMLElement[] = [];
                if (bloco.matches('.totals')) {
                    let linha = corpoTabela!.lastElementChild as HTMLElement | null;
                    while (linha) {
                        ultimoGrupo.unshift(linha);
                        if (linha.classList.contains('item-row')) break;
                        linha = linha.previousElementSibling as HTMLElement | null;
                    }
                    ultimoGrupo.forEach(linha => linha.remove());
                    if (!corpoTabela!.rows.length) moldura!.remove();
                }
                novaPagina();
                if (ultimoGrupo.length) corpoTabela!.append(...ultimoGrupo);
                else moldura!.remove();
                conteudo!.append(final);
                if (!cabe()) throw new Error('Um bloco de totalizacao ou observacoes excede o espaco util de uma folha A4.');
            }
        }
        // Pagamento e indivisivel e aparece apenas na ultima folha, sem levar os totais junto.
        atualizarLimite(true);
        if (!cabe()) {
            atualizarLimite(false);
            novaPagina();
            moldura!.remove();
            atualizarLimite(true);
            if (!cabe()) throw new Error('Os dados para pagamento excedem o espaco util de uma folha A4.');
        }
        paginasDocumento.forEach((pagina, indice) => {
            if (indice < paginasDocumento.length - 1) {
                pagina.querySelector('.print-bottom-block .payment-section')?.remove();
            }
            const contador = pagina.querySelector('.footer-page > div');
            if (contador) contador.textContent = `Pag.: ${indice + 1} de ${paginasDocumento.length}`;
        });
    }
    return folhas;
}
